<template>
    <div class="md-quick-search template1" v-if="filteredList.length > 0">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div class="mg-title" v-if="selectedQuickSearch.title" v-html="formatFontSize(selectedQuickSearch.title, '--mg-title-size')"></div>
            <div class="list">
                <ul :class="{ 'quick-list': true, collapse: collapse }">
                    <li
                        v-for="item in filteredList"
                        :key="item.id"
                        class="quick-search-item"
                        :class="{ hot: item.hot }"
                    >
                        <a
                            v-if="item.type != 'link'"
                            :href="item.href"
                            :title="item.title"
                            rel="noopener noreferrer"
                        >
                            <span class="search-title">{{ item.title }}</span>
                            <span
                                v-if="item.hot"
                                class="hot-search iconfont icon-star-fill"
                            ></span>
                            <Count
                                :max="mlsCount"
                                :count="
                                    countMap[item.key] === undefined
                                        ? -1
                                        : countMap[item.key]
                                "
                            />
                        </a>
                        <a
                            v-else
                            :href="item.url"
                            :title="item.title"
                            rel="noopener noreferrer"
                        >
                            <span class="search-title">{{ item.title }}</span>
                            <span
                                v-if="item.hot"
                                class="hot-search iconfont icon-star-fill"
                            ></span>
                        </a>
                    </li>
                </ul>
                <span
                    v-if="showmore"
                    class="quicksearch-more"
                    @click="toggleShowMore"
                >{{ $t('md-quick-search.viewMore')
                }}<i class="iconfont icon-next"></i>
                </span>
            </div>
        </module-box>
    </div>
</template>

<script>
import common from '../index';
export default {
    ...common
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-quick-search.template1 {
    .list {
        overflow: hidden;
        .quick-list {
            width: 100%;
            padding-top: 9px;
            overflow: hidden;
            li {
                width: calc((100% - 62px) / 3);
                float: left;
                position: relative;
                box-sizing: content-box;
                padding: 10px 0;
                border-bottom: 1px dashed #e9e9e9;
                margin-left: 30px;
                a {
                    display: flex;
                    align-items: center;
                    .search-title {
                        font-size: 14px;
                        text-align: left;
                        height: 17px;
                        line-height: 17px;
                        display: inline-block;
                        @include ellipsis();
                        max-width: calc(100% - 65px);
                        color: #505050;
                        &.hot {
                            max-width: calc(100% - 100px);
                        }
                    }
                    .hot-search {
                        display: inline-block;
                        margin: 0 8px;
                        height: 15px;
                        width: 15px;
                        flex-shrink: 0;
                        @include color-theme('background-color');
                        color: white;
                        line-height: 15px;
                        text-align: center;
                        font-size: 10px;
                    }
                    .num {
                        margin-left: auto;
                        font-size: 12px;
                        height: 17px;
                        line-height: 17px;
                        padding: 0 5px;
                        color: #fff;
                        @include color-theme('background-color');
                        border-radius: 8.5px;
                    }
                }
                &:nth-child(3n + 1) {
                    margin-left: 0;
                }
                &:nth-child(1),
                &:nth-child(2),
                &:nth-child(3) {
                    &:before {
                        content: '';
                        position: absolute;
                        top: -9px;
                        width: 100%;
                        height: 1px;
                        background-color: #e6e6e6;
                    }
                }
            }
        }
        .quicksearch-more {
            display: none;
        }
    }

    @include media-1080 {
        .list {
            .quick-list {
                li {
                    width: calc((100% - 30px) / 2);
                    &:nth-child(3n + 1) {
                        margin-left: 30px;
                    }
                    &:nth-child(2n + 1) {
                        margin-left: 0;
                    }
                    &:nth-child(3) {
                        &:before {
                            content: none;
                        }
                    }
                }
            }
        }
    }

    @include media-600 {
        .list {
            .quick-list {
                width: 100%;
                margin-right: 0;
                margin-top: 0;
                margin-bottom: 0;
                li {
                    // box-sizing: border-box;
                    width: 100%;
                    display: block;
                    margin-left: 0;

                    &:after {
                        display: none;
                    }
                    .num {
                        right: 0px;
                        font-size: 14px;
                    }
                    &:nth-child(3n + 1) {
                        margin-left: 0;
                    }
                    &:nth-child(2) {
                        &:before {
                            content: none;
                        }
                    }
                }
                &.collapse {
                    overflow: hidden;
                    & + .quicksearch-more {
                        display: inline-block;
                    }
                    li {
                        display: none;
                        &:nth-child(-n + 5) {
                            display: block;
                        }
                    }
                }
            }
            .quicksearch-more {
                display: none;
                float: right;
                color: #787878;
                font-size: 13px;
                height: 30px;
                margin-top: 10px;
                text-align: right;
                cursor: pointer;
            }
        }
    }
}
</style>
